"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorAttachments = void 0;
const core_1 = require("@material-ui/core");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useUpload_1 = __importDefault(require("@opsbase/react-gql-hooks/uploadfile/useUpload"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const FileUploadIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FileUploadIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    hiddenVis: {
        visibility: 'hidden',
    },
    addFile: {
        padding: 0,
        marginLeft: 'auto',
        marginRight: 25,
    },
    smallSpinner: {
        size: 24,
    },
    deleteIcon: {
        color: lib_palette_1.default.PastelBlue.main,
        ['&:hover']: {
            color: lib_palette_1.default.error.main,
        },
    },
});
function QuestionEditorAttachments(props) {
    const { config, onChange, disabled = false } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const upload = (0, useUpload_1.default)();
    const [files, setFiles] = (0, react_1.useState)(config.richInfo.files || []);
    const [uploading, setUploading] = (0, react_1.useState)(-1);
    const saveNow = (0, react_1.useMemo)(() => newFiles => {
        if (disabled)
            return;
        setFiles(newFiles);
        config.richInfo.files = newFiles;
        onChange(config);
    }, [config, disabled, onChange]);
    const handleFileRemove = (0, react_1.useCallback)((file, index) => __awaiter(this, void 0, void 0, function* () {
        if (disabled)
            return;
        setUploading(index);
        yield upload({
            fileName: file,
            userImage: null,
        });
        saveNow(files.filter(f => f !== file));
        setUploading(null);
    }), [disabled, files, saveNow, upload]);
    const handleFileInput = (0, react_1.useCallback)((event) => __awaiter(this, void 0, void 0, function* () {
        if (disabled)
            return;
        const input = event.target;
        const file = input.files[0];
        setUploading(files.length);
        saveNow([...files, file.name]);
        yield upload({
            fileName: file.name,
            userImage: file,
        }, {
            context: {
                hasUpload: !!file, // activate Upload link
            },
        });
        setUploading(null);
    }), [disabled, files, saveNow, upload]);
    return (react_1.default.createElement(Pane_1.default, null, files === null || files === void 0 ? void 0 :
        files.map((file, index) => {
            return (react_1.default.createElement(Horizontal_1.default, { key: `${file}_${index}`, centered: true },
                react_1.default.createElement(Horizontal_1.default, { justify: "flex-start", centered: true },
                    react_1.default.createElement(FileUploadIcon_1.default, null),
                    react_1.default.createElement(Text_1.default, { color: "darkgrey" }, file)),
                uploading === index ? (
                //for last file show progress in case its not yet uploading.
                react_1.default.createElement(core_1.CircularProgress, { style: { margin: 6 }, disableShrink: true, variant: "indeterminate", size: 24 })) : (react_1.default.createElement(core_1.IconButton, { disabled: disabled, onClick: () => handleFileRemove(file, index) },
                    react_1.default.createElement(DeleteIcon_1.default, { className: myCss.deleteIcon })))));
        }),
        react_1.default.createElement(Horizontal_1.default, { justify: "flex-end" },
            react_1.default.createElement("label", { htmlFor: "files1" },
                react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.White, component: "span" // needed for the label to work
                    , icon: react_1.default.createElement(FileUploadIcon_1.default, null), disabled: disabled }, lib_i18n_1.default.t('add-a-file')))),
        react_1.default.createElement("input", { type: "file", name: "file", id: "files1", disabled: disabled, className: myCss.hiddenVis, onChange: handleFileInput })));
}
exports.QuestionEditorAttachments = QuestionEditorAttachments;
exports.default = QuestionEditorAttachments;
